<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import Fa from 'svelte-fa'
    import { faXmark } from '@fortawesome/free-solid-svg-icons'
    import FormViewer from '../viewer/form-viewer.svelte'
    import type { PlacedBlock } from '../types/placed-block'
    import type { DocumentHeaderFooter } from '../types/document-header-footer'

    export let title: string
    export let blocks: PlacedBlock[] = []
    export let headerFooter: DocumentHeaderFooter

    let simulatePublic = false

    const dispatch = createEventDispatcher()
</script>

<div class="preview-overlay">
    <div class="preview-bar">
        <span class="preview-tag">Modo de visualização</span>
        <span class="preview-hint">É assim que quem for preencher o formulário vai ver. Nenhuma resposta é salva neste modo de teste.</span>
        <label class="public-toggle">
            <input type="checkbox" bind:checked={simulatePublic} />
            <span class="switch" />
            <span>Simular link público</span>
        </label>
        <button type="button" class="preview-close" on:click={() => dispatch('close')}>
            <Fa icon={faXmark} />
            <span>Voltar a editar</span>
        </button>
    </div>
    <div class="preview-content">
        <FormViewer {title} {blocks} {headerFooter} public={simulatePublic} />
    </div>
</div>

<style>
    .preview-overlay {
        position: fixed;
        inset: 0;
        z-index: 1000;
        background: #f4f5f7;
        display: flex;
        flex-direction: column;
    }
    .preview-bar {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 12px 24px;
        background: #212529;
        color: #fff;
        flex-shrink: 0;
    }
    .preview-tag {
        background: var(--cs2-accent, #4263eb);
        border-radius: 999px;
        padding: 4px 12px;
        font-size: 0.72rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        flex-shrink: 0;
    }
    .preview-hint {
        flex: 1;
        font-size: 0.8rem;
        color: #ced4da;
    }
    .public-toggle {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 0.8rem;
        color: #ced4da;
        cursor: pointer;
        flex-shrink: 0;
    }
    .public-toggle input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }
    .public-toggle .switch {
        position: relative;
        width: 30px;
        height: 17px;
        flex-shrink: 0;
        border-radius: 999px;
        background: #495057;
        transition: background 0.15s ease;
    }
    .public-toggle .switch::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #fff;
        transition: transform 0.15s ease;
    }
    .public-toggle input:checked + .switch {
        background: var(--cs2-accent, #4263eb);
    }
    .public-toggle input:checked + .switch::after {
        transform: translateX(13px);
    }
    .preview-close {
        display: flex;
        align-items: center;
        gap: 8px;
        border: 1px solid #495057;
        background: transparent;
        color: #fff;
        border-radius: 8px;
        padding: 7px 14px;
        font-size: 0.85rem;
        cursor: pointer;
        flex-shrink: 0;
    }
    .preview-close:hover {
        background: #343a40;
    }
    .preview-content {
        flex: 1;
        overflow-y: auto;
    }

    @media (max-width: 900px) {
        .preview-bar {
            flex-wrap: wrap;
        }
        .preview-hint {
            order: 3;
            width: 100%;
        }
    }
</style>
